<template>
  <div id="popup-wrap">
    <van-popup v-model="isShowActivate" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">开通会员</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="popup-content">
          <div class="activate-tips">请前往PC端开通套餐</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Activate",
  data: function () {
    return {
      isShowActivate: false,
    }
  },
  methods: {
    init: function () {
      this.isShowActivate = true;
    },
    handelCancel() {
      this.isShowActivate = false;
    }
  }
}
</script>

<style scoped>
.activate-tips{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #FF4F76;
  text-align: center;
  margin: 25px auto 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/activation/modal/Activate.vue